import { render, staticRenderFns } from "./Liisa.vue?vue&type=template&id=1045244b&scoped=true"
var script = {}
import style0 from "./Liisa.vue?vue&type=style&index=0&id=1045244b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045244b",
  null
  
)

export default component.exports